import { Component, EventEmitter, Inject, OnInit, Output, ViewEncapsulation, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { COUNTRY_CODES } from '@pdqdev/pdq-shared/dist/utils';
import { Subject } from 'rxjs';

@Component({
  selector: 'add-tax-id-dialog',
  templateUrl: './add-tax-id.dialog.html',
  styleUrls: ['./add-tax-id.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AddTaxIdDialog implements OnInit, OnDestroy {
  private destroy$ = new Subject<any>();
  @Output() onAddTaxId = new EventEmitter();

  form: UntypedFormGroup;
  typeOptions = [
    {
      label: 'VAT',
      value: 'VAT',
    },
    {
      label: 'EIN',
      value: 'EIN',
    },
  ];
  countryOptions = COUNTRY_CODES.map((country) => ({ label: country.name, value: country.code }));

  constructor(
    public dialogRef: MatDialogRef<AddTaxIdDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.form = new UntypedFormGroup({
      type: new UntypedFormControl(this.typeOptions[0].value),
      taxId: new UntypedFormControl(),
      country: new UntypedFormControl(this.countryOptions[0].value),
      nick: new UntypedFormControl(),
      description: new UntypedFormControl(),
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit() {}

  onCancel(): void {
    this.dialogRef.close();
  }

  addTaxId(): void {
    const data = {
      type: this.form.controls['type'].value,
      taxId: this.form.controls['taxId'].value,
      country: this.form.controls['country'].value,
      nick: this.form.controls['nick'].value,
      description: this.form.controls['description'].value,
    };
    if (this.form.valid) {
      this.onAddTaxId.emit(data);
      this.dialogRef.close();
    }
  }
}
